<template>
<nav id="mainnav"
  ref="mainnav"
  class="navbar is-transparent"
  v-sticky="{ zIndex: 1, stickyTop: 0 }">
  <div class="container">
    <div class="navbar-menu">
      <div class="navbar-start">
        <a class="nav-item nav-brand"
          href="/">
            <img :src="`${assets}/img/logo_getcloser_25_11_18_3.svg`">
          </a>
      </div>
      <div class="navbar-end">
        <router-link class="navbar-item is-tab"
          active-class="is-active"
          :to="{ path: 'signup' }">{{ $t('navigation.signup') }}</router-link>
        <router-link class="navbar-item is-tab"
          active-class="is-active"
          :to="{ path: 'login' }">{{ $t('navigation.login') }}</router-link>
      </div>
    </div>
  </div>
</nav>
</template>

<script>
export default {
  computed: {
    assets() {
      return process.env.assets || '/static'
    }
  },
  mounted() {
    const mainnav = this.$refs.mainnav
    window.onscroll = () => {
      const offset = window.pageYOffset
      if (offset <= 0) mainnav.classList.remove('js-is-sticky')
      if (offset > 0) mainnav.classList.add('js-is-sticky')
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/mainnav.vue